import React from "react";

import { BsChevronRight } from "react-icons/bs";
import { TABS } from ".";

export default function Sidebar({ activeTab, setActiveTab }) {
  return (
    <div className="patientSidebar">
      <button
        onClick={() => setActiveTab(TABS.APPOINTMENT)}
        className={`dashboardButton ${TABS.APPOINTMENT === activeTab && "dashboardButtonActive"}`}
      >
        <div style={{ width: "20px" }}>{TABS.APPOINTMENT === activeTab && <BsChevronRight color="#000" />}</div>
        <div>{TABS.APPOINTMENT}</div>
      </button>

      <button
        onClick={() => setActiveTab(TABS.KIT_DETAIL)}
        className={`dashboardButton mt-3 ${TABS.KIT_DETAIL === activeTab && "dashboardButtonActive"}`}
      >
        <div style={{ width: "20px" }}>{TABS.KIT_DETAIL === activeTab && <BsChevronRight color="#000" />}</div>
        <div>{TABS.KIT_DETAIL}</div>
      </button>

      <button onClick={() => setActiveTab(TABS.HISTORY)} className={`dashboardButton mt-3 ${TABS.HISTORY === activeTab && "dashboardButtonActive"}`}>
        <div style={{ width: "20px" }}>{TABS.HISTORY === activeTab && <BsChevronRight color="#000" />}</div>
        <div>{TABS.HISTORY}</div>
      </button>

      <button
        onClick={() => setActiveTab(TABS.HEALTH_STATUS)}
        className={`dashboardButton mt-3 ${TABS.HEALTH_STATUS === activeTab && "dashboardButtonActive"}`}
      >
        <div style={{ width: "20px" }}>{TABS.HEALTH_STATUS === activeTab && <BsChevronRight color="#000" />}</div>
        <div>{TABS.HEALTH_STATUS}</div>
      </button>

      <button onClick={() => setActiveTab(TABS.MESSAGE)} className={`dashboardButton mt-3 ${TABS.MESSAGE === activeTab && "dashboardButtonActive"}`}>
        <div style={{ width: "20px" }}>{TABS.MESSAGE === activeTab && <BsChevronRight color="#000" />}</div>
        <div>{TABS.MESSAGE}</div>
      </button>
      <button
        onClick={() => setActiveTab(TABS.CHARTING_NOTES)}
        className={`dashboardButton mt-3 ${TABS.CHARTING_NOTES === activeTab && "dashboardButtonActive"}`}
      >
        <div style={{ width: "20px" }}>{TABS.CHARTING_NOTES === activeTab && <BsChevronRight color="#000" />}</div>
        <div>{TABS.CHARTING_NOTES}</div>
      </button>
      <button
        onClick={() => setActiveTab(TABS.PRESCRIPTION)}
        className={`dashboardButton mt-3 ${TABS.PRESCRIPTION === activeTab && "dashboardButtonActive"}`}
      >
        <div style={{ width: "20px" }}>{TABS.PRESCRIPTION === activeTab && <BsChevronRight color="#000" />}</div>
        <div>{TABS.PRESCRIPTION}</div>
      </button>
      <button
        onClick={() => setActiveTab(TABS.PREP_PROGRAM)}
        className={`dashboardButton mt-3 ${TABS.PREP_PROGRAM === activeTab && "dashboardButtonActive"}`}
      >
        <div style={{ width: "20px" }}>{TABS.PREP_PROGRAM === activeTab && <BsChevronRight color="#000" />}</div>
        <div>{TABS.PREP_PROGRAM}</div>
      </button>
    </div>
  );
}
